<div class="flex flex-col h-20 w-full py-2 items-center justify-between lg:flex-row lg:px-3" [ngClass]="{
    'bg-pet-adm-color-menu-header': userSession?.rol === rolVet,
    'bg-pet-color-1': userSession?.rol === rolClient || userSession === null
  }">
    <div class="flex w-full items-center justify-between px-3 lg:px-0 lg:w-auto">
        <div>
            <img style="cursor: pointer;" [routerLink]="['/public/home']" src="assets/images/pet24-icon-1.png" alt="" class="h-16" />
        </div>
        <button type="button"
        class="flex items-center w-auto h-auto w-auto ml-1 text-6xl lg:hidden hover:bg-pet-color-2 focus:outline-none focus:ring-2 focus:ring-blue-200"
        (click)="toggleCollapse()">
            <mat-icon inline="true" class="text-white">menu</mat-icon>
        </button>
    </div>
    <div #itemsMenu class="hidden flex flex-col gap-1 w-full z-50 lg:flex lg:flex-row pt-2 lg:pt-0 lg:gap-6 lg:flex lg:flex-row lg:items-center lg:justify-end lg:w-full" [ngClass]="{
        'bg-pet-adm-color-menu-header': userSession?.rol === rolVet,
        'bg-pet-color-1': userSession?.rol === rolClient || userSession === null,
        'hidden': !isCollapsed,
      }">
        <div *ngFor="let item of menu; let i = index" class="w-full lg:w-auto">
            <button *ngIf="!item.link" [routerLink]="[item.path]" (click)="toggleCollapseItemsMenu()"
            [ngClass]="{
                'bg-pet-color-2': optionSelected === i,
                'hover:text-sky-500': optionSelected !== i,
                'hover:border': optionSelected !== i,
                'hover:border-sky-500': optionSelected !== i
                }" class="text-white font-semibold py-2 px-5 rounded w-full flex justify-start lg:w-auto lg:justify-center">
                {{ item.title }}
            </button>

            <button *ngIf="item.link" [ngClass]="{
                  'bg-pet-color-2': optionSelected === i,
                  'hover:text-sky-500': optionSelected !== i,
                  'hover:border': optionSelected !== i,
                  'hover:border-sky-500': optionSelected !== i
                }" class="text-white font-semibold py-2 px-5 rounded w-full flex justify-start lg:w-auto lg:justify-center">
                <a [href]="item.path" target="_blank" class="underline">
                    {{ item.title }}
                </a>
            </button>
        </div>

        <button *ngIf="!this.userSession" (click)="toggleCollapseItemsMenu()"
            class="bg-pet-color-3 m-3 hover:bg-pet-color-3-1 text-white font-bold py-2 px-5 rounded-full flex items-center gap-2 lg:m-0"
            [routerLink]="['/auth/sign-in']">
            <span class="material-icons"> person </span>
            Iniciar Sesión
        </button>
        <button *ngIf="this.userSession" (click)="toggleCollapseItemsMenu()"
            class="bg-pet-color-3 m-3 lg:m-0 hover:bg-pet-color-3-1 text-white font-bold py-2 px-5 rounded-full flex items-center gap-2"
            [routerLink]="['/auth/sign-out']">
            <span class="material-icons"> person </span>
            Cerrar Sesión
        </button>
    </div>
</div>
